var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,22.6 C17.6,22.6 22.6,17.5 22.6,11.3 C22.6,5 17.5,0 11.3,0 C5,0 0,5.1 0,11.3 C0,17.5 5.1,22.6 11.3,22.6 Z",
    id: "Path",
    fill: "#2C374B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,7.2 C17.4,7.1 12.5,4.2 11.9,4 C11.7,3.9 11.2,3.8 10.9,3.9 C10.6,4 5.4,7 5.2,7.2 C5.1,7.3 5,7.5 4.9,7.6 C4.8,7.8 4.8,7.9 4.8,11.4 L4.8,15 L5.5,15.4 C5.9,15.6 6.2,15.8 6.2,15.8 C6.3,15.8 11,8.3 11,8.2 C11,8.1 9.9,8.1 9.6,8.2 C9.2,8.3 8.9,8.5 8.7,8.7 C8.6,8.8 8,9.8 7.2,10.9 C6.5,12 5.9,13 5.9,13 C5.9,13 5.9,12 5.9,10.6 L5.9,8.1 L6,8 C6.2,7.8 11.3,4.9 11.5,4.9 C11.6,4.9 11.7,4.9 12.9,5.6 C13.3,5.8 14.4,6.4 15.3,7 C16.2,7.5 17,8 17.1,8.1 L17.2,8.2 L17.2,13.4 L14.7,9.5 C14.6,9.3 14.5,9.1 14.4,9 L14.4,9 L14.4,9 C14.4,9 14.4,9 14.4,9 C14.4,9 14.3,9.2 13.7,10.2 C13.6,10.3 13.5,10.5 13.5,10.6 L13.4,10.8 L13.4,10.8 L13.4,10.8 L13.5,10.9 L13.6,11 C13.6,11 13.6,11.1 13.7,11.1 L13.9,11.4 C13.9,11.4 13.9,11.5 14,11.5 C14.1,11.6 14.2,11.8 14.2,11.9 C14.2,11.9 14.2,11.9 14.2,12 L16.3,15.4 L16.1,15.5 C16,15.6 15.9,15.6 15.8,15.6 L13.2,11.6 L13.1,11.5 L12.9,11.9 L12.9,11.9 L11.9,13.5 L11.9,13.5 L13.9,16.7 C13.6,16.9 11.9,18.1 11.8,18.1 C11.7,18.1 9.4,16.6 9.5,16.5 C9.5,16.5 10.2,15.3 11,13.9 L11,13.9 C11.7,12.7 12.6,11.2 13.2,10.2 C13.9,9 14.2,8.4 14.2,8.4 C14.2,8.4 13.7,8.4 13.1,8.4 L12.1,8.4 L9.8,12.2 C9,13.6 8.2,14.9 7.8,15.6 L7.8,15.6 C7.1,15.7 6.9,15.9 6.9,15.9 L6.8,16.1 L8.6,17.1 C9.6,17.7 10.5,18.2 10.7,18.3 C11,18.5 11.5,18.5 11.7,18.5 C11.9,18.4 17.1,15.4 17.4,15.2 C17.5,15.1 17.6,15 17.7,14.8 L17.8,14.5 L17.8,11.2 L17.8,7.9 L17.7,7.7 C17.7,7.5 17.5,7.3 17.5,7.2 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#24A2EE",
    fillRule: "nonzero",
    points: "17 13.3 14 8.7 12.9 10.5 15.8 15.2 17.1 14.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#24A2EE",
    fillRule: "nonzero",
    points: "15.6 15.8 12.6 11.2 11.3 13.2 13.7 17 15.2 16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,8.1 L11.3,4.9 L16.8,8.1 L16.8,14.5 L11.3,17.7 L7.2,15.4 L6.7,16.3 L11.2,18.9 C11.3,19 11.4,19 11.5,18.9 L17.8,15.3 C17.9,15.2 18,15.1 18,15 L18,7.8 C18,7.7 17.9,7.6 17.8,7.5 L11.5,3.9 C11.4,3.8 11.3,3.8 11.2,3.9 L4.9,7.4 C4.8,7.5 4.7,7.6 4.7,7.7 L4.7,14.9 C4.7,15 4.8,15.1 4.9,15.2 L6.2,15.9 L6.8,15 L5.9,14.5 L5.9,8.1 L5.8,8.1 Z",
    id: "Path",
    fill: "#98BCDC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "13.7 8.1 11.6 8.1 6.7 16.1 8.4 17.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,8.9 C8.9,8.1 10.3,8.1 10.9,8.2 L6.1,15.9 C5.9,15.8 5.5,15.6 5.2,15.4 C4.8,15.2 4.7,15.2 4.7,14.9 L4.7,14.5 C5.8,12.9 7.9,9.7 8.4,8.9 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.7409d2cb9e6ddf649a3058829b2bf6f8.svg";
export { ForwardRef as ReactComponent };